var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5375_1028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0H4C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H28C30.2091 32 32 30.2091 32 28V4C32 1.79086 30.2091 0 28 0Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 16.0004C26 21.5232 21.5228 26.0004 16 26.0004C14.8358 26.0004 13.718 25.8014 12.6789 25.4357C12.2414 24.3772 12 23.217 12 22.0004C12 19.7792 12.8047 17.7459 14.1384 16.1762C15.31 17.8818 17.2744 19.0004 19.5 19.0004C21.8615 19.0004 23.9289 17.741 25.0672 15.8572C25.3065 15.4612 26 15.5377 26 16.0004Z",
    fill: "#238856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16C6 20.3586 8.78852 24.0659 12.6789 25.4353C12.2414 24.3768 12 23.2166 12 22C12 19.7788 12.8047 17.7455 14.1384 16.1758C13.4203 15.1303 13 13.8642 13 12.5C13 10.1384 14.2594 8.07105 16.1432 6.93276C16.5392 6.69347 16.4627 6 16 6C10.4771 6 6 10.4771 6 16Z",
    fill: "#238856"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5375_1028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMoon);
export default __webpack_public_path__ + "static/media/greenMoon.755947bc3942f5d657d8ac3301ea3036.svg";
export { ForwardRef as ReactComponent };